import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import {
  getTernaryValue,
  getQuantityFromItem,
  isCateringDisposition,
  isSupportedTenantCode,
} from 'common/utilities/utils';
import { priceFixed_value } from 'common/constants/SharedConstants';
import { REVIEW_ORDER } from '../Constants/Constants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image/index';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const PastOrderListComponent = props => {
  const {
    pastOrdersData,
    settingsRecommendation,
    rangeValue,
    reorderBtnHandler,
    onUpdateRange,
    carousal,
    getDate,
    currencySymbol,
    currencyConversionFactor,
  } = props;
  const { ORDER } = TRANSLATE_MAPPING_KEY;
  return (
    <>
      <div
        className={`pastorderCard-list order-list-au ${getTernaryValue(
          pastOrdersData?.length <= 3,
          'past-order-au-card',
          null,
        )}`}
      >
        <CarauselComp settings={settingsRecommendation} carousalRef={carousal}>
          {pastOrdersData?.map(order => {
            const {
              items = [],
              store: { name: storeName },
              service: serviceName,
              id,
              name,
              orderedOn,
              total,
              referenceNumber,
            } = order;
            const quantity = getQuantityFromItem(items);
            return (
              !isCateringDisposition(serviceName) && (
                <div>
                  <div className='pastorder-card-au ml-0'>
                    <div className='pastorder-card-details'>
                      <p className='pastorder-card-main-text mb-1'>{translateWithI18Next(serviceName)}</p>
                      <p className='pastorder-card-date-text mb-1'>{getDate(orderedOn)}</p>
                      <div className='pastorder-item-info'>
                        {name && (
                          <ImageComponent srcFile={IMAGE_PATH.FavouriteActiveBlack} className='account-icon mr-2' />
                        )}
                        <span
                          className={`text-camelcase pastorder-card-text brand-black ${
                            name?.length > 20 && 'order-tracking-number'
                          }`}
                        >
                          {name ? name : `${translateWithI18Next(ORDER)} #${referenceNumber}`}
                        </span>
                      </div>
                    </div>
                    <div className='pastorder-card-item-info'>
                      <div className='pastorder-line'></div>
                      <div className='past-order-store-info'>
                        <span className='pastorder-card-text brand-black store-name'>{storeName}</span>
                      </div>
                      <div className='item-desc'>
                        <span className='item-quantity mr-2'>{`${quantity}`}</span>
                        <span className='pastorder-card-text pastorder-text dark-gray'>{`${getTernaryValue(
                          quantity === 1,
                          translateWithI18Next(TRANSLATE_MAPPING_KEY?.CART_ITEM),
                          translateWithI18Next(TRANSLATE_MAPPING_KEY?.CART_ITEMS),
                        )}`}</span>
                        {!isSupportedTenantCode() && (
                          <span className='pastorder-card-text pastorder-total brand-black'>
                            {currencySymbol}
                            {(total / currencyConversionFactor).toFixed(priceFixed_value)}
                          </span>
                        )}
                      </div>
                      <div className='pastorder-line'></div>
                    </div>
                    <div
                      className='pastorder-card-button-conatiner'
                      onClick={() => reorderBtnHandler(order)}
                      data-testid={`pastorder-btn-test-${id}`}
                    >
                      <ContainedButton
                        data-testid='pastorder-card-button-test'
                        variant={ButtonType.primary}
                        aria-label={'Reorder button'}
                      >
                        <span>{translateWithI18Next(REVIEW_ORDER)}</span>
                      </ContainedButton>
                    </div>
                  </div>
                </div>
              )
            );
          })}
        </CarauselComp>
        {pastOrdersData?.length > 2 && (
          <div className='pastorder-slideContainer'>
            <input
              className='pastorder-slider'
              type='range'
              min='0'
              max={pastOrdersData?.length - 1}
              value={rangeValue}
              id='myRange'
              data-testid='myRange'
              onChange={onUpdateRange}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default PastOrderListComponent;
